<div class="restoreSaveButtonContainer">
  <button class="btn btn-outline-secondary form-button" type="button" (click)="restoreClicked.emit()"
          data-test="restore-button" [disabled]="isRestoreDisabled">Restore
  </button>
  <button class="btn button-blue form-button" type="button" (click)="saveClicked.emit()"
          [disabled]="isSaveDisabled || showSpinner" data-test="save-button">{{ showSpinner ? '' : 'Save' }}
    <app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>
  </button>
</div>
